// extracted by mini-css-extract-plugin
module.exports = {"home_container":"home_home_container__2BxlV","action_btn":"home_action_btn__3Il-v"};